import { RootState } from 'store/types';
import { createSelector } from 'reselect';

export const notificationsPreferencesSelector = (state: RootState) =>
  state.notifications.preferences;

export const notificationsPreferencesDataSelector = createSelector(
  notificationsPreferencesSelector,
  preferences => preferences.data
);

export const notificationsChannelsSelector = createSelector(
  notificationsPreferencesDataSelector,
  data => data.channels
);

export const notificationsCategoriesSelector = createSelector(
  notificationsPreferencesDataSelector,
  data => data.categories
);

export const notificationsHealthCloudIdSelector = createSelector(
  notificationsPreferencesDataSelector,
  data => data.healthCloudId
);

export const notificationsPreferencesFetchingSelector = createSelector(
  notificationsPreferencesSelector,
  preferences => preferences.isFetching
);

export const notificationsPreferencesErrorSelector = createSelector(
  notificationsPreferencesSelector,
  preferences => preferences.error
);

export const notificationsProxiesSelector = (state: RootState) => state.notifications.proxies;

export const notificationsProxiesDataSelector = createSelector(
  notificationsProxiesSelector,
  proxies => proxies.data
);

export const notificationsProxiesFetchingSelector = createSelector(
  notificationsProxiesSelector,
  proxies => proxies.isFetching
);

export const notificationsProxiesErrorSelector = createSelector(
  notificationsProxiesSelector,
  proxies => proxies.error
);

export const notificationsHipaaSelector = (state: RootState) => state.notifications.hipaa;

export const notificationsHipaaAgreementSelector = createSelector(
  notificationsHipaaSelector,
  hipaa => hipaa.agreementHtml
);

export const notificationsHipaaAgreementObjectSelector = createSelector(
  notificationsHipaaSelector,
  hipaa => hipaa.agreementObject
);

export const notificationsHipaaPatientSelector = createSelector(
  notificationsHipaaSelector,
  hipaa => hipaa.patient
);

export const notificationsHipaaPatientIdSelector = createSelector(
  notificationsHipaaPatientSelector,
  patient => patient && patient.patientId
);

export const notificationsHipaaPatientNameSelector = createSelector(
  notificationsHipaaPatientSelector,
  patient => patient && patient.displayName
);

export const notificationsHipaaFetchingSelector = createSelector(
  notificationsHipaaSelector,
  hipaa => hipaa.isFetching
);

export const notificationsHipaaSigningSelector = createSelector(
  notificationsHipaaSelector,
  hipaa => hipaa.isSigning
);

export const notificationsHipaaErrorSelector = createSelector(
  notificationsHipaaSelector,
  hipaa => hipaa.error
);

export const notificationsPushTokenSelector = (state: RootState) => state.notifications.pushToken;

export const notificationsPushTokenAddressSelector = createSelector(
  notificationsPushTokenSelector,
  pushToken => pushToken.tokenAddress
);
